import { useState } from 'react';
import Lakshyavedicon from "../images/lakhyaved icon.jpeg";
import businessgrowsumandas from "../images/business_grow.jpeg";
// import AddLandingbook from '../AddLandingbook';
import businessgrow from "../images/business.jpg";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import ContactForm from './ContactForm';


function Landingpage() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <div>
            <br />

            <div className="album py-1">
                <div className="container">
                    <center>
                        <img src={Lakshyavedicon} className="" height="90px" width="90px" alt="Lakshyaved" />
                    </center>
                    <center>
                        <h4 style={{ color: "maroon" }}>বাংলা ভাষায় এই প্রথমবার</h4>
                    </center>

                </div>
            </div>
            <div className="album py-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-7 mt-3">
                            <h1 className='justify' style={{ color: "darkBlue" }}> <b style={{ color: "maroon" }}>বিজনেস গ্রোথ ওয়েবিনার</b> । এবার আপনিও শিখবেন ব্যবসা বৃদ্ধি করার খুটিনাটি ।  <b style={{ color: "goldenrod" }}>Live একদম ফ্রি-তে</b> । যা শেখার পর আপনার বিজনেস গ্রোথ হবেই হবে। এটা আমাদের …গ্যারান্টি।</h1>
                        </div>
                        <div className="col-md-5 mt-3">
                            <div className='businesstraIningconsultancyberhampore'>
                                <img src={businessgrow} className="card-img-top" alt="businessgrow-sumandas" />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <br />



            <div className="album py-0">
                <div className="container">
                    <div className="btn-grad12  mb-2">
                        <center>
                            <Button variant="info" onClick={handleShow}>
                                <h3 className='mt-3'> আমি শিখতে চাই </h3>
                            </Button>

                            <Modal
                                show={show}
                                onHide={handleClose}
                                backdrop="static"
                                keyboard={false}
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>Lakshyaved.org</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>

                                    <ContactForm />
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleClose}>
                                        Close
                                    </Button>

                                </Modal.Footer>
                            </Modal>
                        </center>
                    </div>
                </div>
            </div>
            <br />
            <div className="album py-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mt-3">

                            <div className="card-body">
                                <h4 className="card-title mb-3">📌 এখানে যা শিখবেন :</h4>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b>যেকোনো ব্যবসার ৭টি স্তম্ভের জন্য কাঠামো নির্দেশিকা।</p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b>মার্কেটিং ( Marketing ) কৌশল (অফলাইন এবং ডিজিটাল মার্কেটিং)</p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b>অগ্রিম বিক্রয়  ( Advance Sales )কৌশল।</p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b>ব্যবসায়ে সিস্টেম/প্রযুক্তির ( System / Techonology ) ব্যবহার কীভাবে বিকাশ করা যায়।</p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b>ফান্ডিং, ইনভেস্টমেন্ট ও ব্যবসার স্থায়িত্বশীলতা</p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b>দল গঠন এবং দলের গুরুত্ব।</p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b>ঋণ ও তহবিলের উৎস</p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b> পেমেন্ট বকেয়াসংগ্রহ</p>

                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b> বিনিয়োগ ( Investment ) ব্যবস্থাপনা</p>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card-body">
                                <h4 className="card-title mb-3">🎯 এই ওয়েবিনারটি কার জন্য?</h4>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" style={{ color: "green" }} width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                </svg> </b>1.	নিধি,(NIDHI ) মাইক্রোফাইন্যান্স (MFI)/এনবিএফসি( NBFC ) সমবায় প্রতিষ্ঠান
                                    ব্যবসার মালিকরা
                                </p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" style={{ color: "green" }} width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                </svg></b> 2.	ডাক্তার ( Doctors ) , মেডিকেল প্রতিনিধি (MR ), ডায়াগনস্টিক সেন্টার, ক্লিনিক, মেডিকেল হাব, প্যারামেডিক্যাল সেন্টার।
                                    অ্যাডভোকেট (ADVOCATE ), ট্যাক্স কনসালট্যান্ট, চার্টার্ড অ্যাকাউন্ট্যান্ ( CA ) Professionals /Self Employed.
                                </p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" style={{ color: "green" }} width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                </svg> </b> 3.	*পাইকারি ব্যবসা, শপিং মল
                                    *হোটেল ও রেস্তোরাঁ
                                    *হার্ডওয়্যার ব্যবসা
                                    *আসবাবপত্র ও জিনিসপত্র
                                    *যেকোন খুচরা ব্যবসা
                                </p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" style={{ color: "green" }} width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                </svg> </b>4. COACHING BUISNESS( ব্যবসা), Edutech Business
                                </p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" style={{ color: "green" }} width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                </svg> </b>5. স্টার্ট আপ ভেঞ্চারস( Venture/business )
                                </p>
                                <p><small>***উপরোক্ত ধরণের ব্যবসার মালিক বা ব্যবস্থাপনা অংশগ্রহণ করতে পারবেন
                                    তাদের সম্মতি প্রদানের মাধ্যমে তাদের বিবরণ আমাদের এবং সোশ্যাল মিডিয়া প্ল্যাটফর্মের সাথে শেয়ার করতে.**Terms & Conditions applied.
                                </small></p>



                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card-body">
                                <h4 className="card-title mb-3">🎯 কেন এই ওয়েবিনারে অংশগ্রহণ করবেন ?</h4>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b>১. প্রধান ব্যবসায়িক সমস্যার সমাধান।</p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b>২. ব্যবসায়িক কাঠামোর জন্য নির্দেশিকা।</p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b>৩.
                                    স্বল্প সময়ের মধ্যে 10X গুণ ব্যবসায়িক বৃদ্ধি।

                                    নিয়মতান্ত্রিক উপায়ে ব্যবসায়িক বৃদ্ধি
                                </p>
                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b> ৪. সামগ্রিক ব্যবসা, L1 উপায়ে ব্যবস্থাপনা কৌশল</p>

                                <p className="card-text mb-2"><b><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" style={{ color: "green" }} fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                </svg> </b>৫. সহজ বাংলা বা ইংরেজি ভাষায় উপস্থাপনা।</p>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <hr />
            <div className="album py-3">
                <div className="container">
                    <div className="row">
                        <div className="col-md-7 mt-3">
                            <h1 className='justify' style={{ color: "darkBlue" }}> আমাদের কাজ হল <b style={{ color: "maroon" }}>আপনাকে সারপ্রাইস দেওয়া,</b> আপনি ভাবতেও পারবেন না – যে এমন বিস্তারিত ভাবে <b style={{ color: "goldenrod" }}>বিজনেস গ্রোথ কেউ ফ্রীতে শেখাতে</b> পারে। আপনি শুধু অবাক হয়ে ক্লাস করবেন এটা আমাদের ……… <b style={{ color: "green" }}>গ্যারান্টি ।</b></h1>
                        </div>
                        <div className="col-md-5 mt-3">
                            <div className='businesstraIningconsultancyberhampore'>
                                <img src={businessgrowsumandas} className="card-img-top" alt="businessgrow-sumandas" />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div style={{ color: "Green", justifyContent: 'flex-start', margin: "2px" }} className=" shadow mb-1">

                <div className="album py-0">
                    <div className="container">
                        <div className="btn-grad13  mb-2">
                            <center>
                                <Button variant="info" onClick={handleShow}>
                                    <h3 className='mt-3'> আমি শিখতে চাই </h3>
                                </Button>

                                <Modal
                                    show={show}
                                    onHide={handleClose}
                                    backdrop="static"
                                    keyboard={false}
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title>Lakshyaved.org </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>

                                        <ContactForm />

                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose}>
                                            Close
                                        </Button>

                                    </Modal.Footer>
                                </Modal>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Landingpage